import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, TOKEN_KEY } from "../lib/api";
import { LogoMark } from "../components/site/Logo";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success("Welcome back");
      nav("/admin");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  const field = "w-full bg-transparent border-b border-ink/25 focus:border-ink outline-none py-3 text-ink placeholder:text-ink/50";

  return (
    <div className="min-h-screen bg-paper text-ink grid place-items-center px-5 relative">
      <form data-testid="admin-login-form" onSubmit={submit} className="relative w-full max-w-sm">
        <Link to="/"><LogoMark className="w-14 h-14" /></Link>
        <h1 className="mt-8 font-display font-extrabold text-4xl tracking-tight">Admin <span className="font-serif-i text-[var(--brass-deep)]">desk.</span></h1>
        <p className="mt-2 text-ink/70 text-sm">Manage insights, clients, reviews and enquiries.</p>
        <div className="mt-10 space-y-5">
          <input data-testid="admin-login-email-input" type="email" required placeholder="Email" className={field} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-login-password-input" type="password" required placeholder="Password" className={field} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {error && <p data-testid="admin-login-error" className="mt-4 text-sm text-red-600">{error}</p>}
        <button data-testid="admin-login-submit-button" disabled={busy} className="mt-8 w-full rounded-full bg-ink text-paper py-3.5 font-semibold hover:bg-brass hover:text-paper transition-colors disabled:opacity-60">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
